import { useEffect } from "react";
import { motion } from "framer-motion";

export const MentionsLegalesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="mentions-legales-page" className="pt-32">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
              Mentions légales
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-surface">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="prose prose-invert max-w-none space-y-8"
          >
            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Éditeur du site
              </h2>
              <div className="text-text-secondary space-y-2">
                <p><strong className="text-gold">Raison sociale :</strong> Emplacement-immo</p>
                <p><strong className="text-gold">Activité :</strong> Chasseur immobilier et Agent immobilier</p>
                <p><strong className="text-gold">Zone d'intervention :</strong> Paris et Île-de-France</p>
                <p><strong className="text-gold">Email :</strong> infos@emplacement-immo.com</p>
              </div>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Activité réglementée
              </h2>
              <p className="text-text-secondary">
                L'activité d'agent immobilier est réglementée par la loi n° 70-9 du 2 janvier 1970 
                (dite loi Hoguet) et son décret d'application n° 72-678 du 20 juillet 1972.
              </p>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Hébergement
              </h2>
              <p className="text-text-secondary">
                Ce site est hébergé par des services d'hébergement cloud professionnels 
                garantissant la sécurité et la disponibilité des données.
              </p>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Propriété intellectuelle
              </h2>
              <p className="text-text-secondary">
                L'ensemble du contenu de ce site (textes, images, logos, graphismes) est protégé 
                par le droit d'auteur. Toute reproduction, représentation, modification, publication, 
                adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le 
                procédé utilisé, est interdite, sauf autorisation écrite préalable d'Emplacement-immo.
              </p>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Protection des données personnelles (RGPD)
              </h2>
              <div className="text-text-secondary space-y-4">
                <p>
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la 
                  loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, 
                  de suppression et d'opposition concernant vos données personnelles.
                </p>
                <p>
                  Les données collectées via le formulaire de contact sont utilisées exclusivement 
                  pour répondre à vos demandes et vous accompagner dans votre projet immobilier. 
                  Elles ne sont jamais cédées à des tiers sans votre consentement.
                </p>
                <p>
                  Pour exercer vos droits ou pour toute question relative à vos données personnelles, 
                  contactez-nous à : <span className="text-gold">infos@emplacement-immo.com</span>
                </p>
              </div>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Cookies
              </h2>
              <div className="text-text-secondary space-y-4">
                <p>
                  Ce site utilise des cookies pour améliorer votre expérience de navigation et 
                  mesurer l'audience. Lors de votre première visite, une bannière vous permet 
                  d'accepter ou de refuser l'utilisation de ces cookies.
                </p>
                <p>
                  Les cookies analytiques (Google Analytics via Google Tag Manager) nous permettent 
                  de comprendre comment les visiteurs interagissent avec le site. Ces données sont 
                  anonymisées et ne permettent pas de vous identifier personnellement.
                </p>
              </div>
            </div>

            <div className="bg-white border border-line p-8 shadow-sm">
              <h2 className="text-xl font-bold text-text-primary mb-4">
                Responsabilité
              </h2>
              <p className="text-text-secondary">
                Emplacement-immo s'efforce d'assurer l'exactitude et la mise à jour des informations 
                diffusées sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, la précision 
                ou l'exhaustivité des informations mises à disposition. En conséquence, nous déclinons 
                toute responsabilité pour toute imprécision, inexactitude ou omission portant sur 
                des informations disponibles sur ce site.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
